import { render, staticRenderFns } from "./ListCourseDetail.vue?vue&type=template&id=7729c51b&scoped=true&"
import script from "./ListCourseDetail.vue?vue&type=script&lang=js&"
export * from "./ListCourseDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7729c51b",
  null
  
)

export default component.exports